import { render } from "./QInputS.vue?vue&type=template&id=6a02719a&ts=true"
import script from "./QInputS.ts?vue&type=script&lang=ts&external"
export * from "./QInputS.ts?vue&type=script&lang=ts&external"

import "./QInputS.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QSkeleton from 'quasar/src/components/skeleton/QSkeleton.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QSkeleton});
